export enum SlotProvider {
  OCTOPLAY = "OCTOPLAY",
  NOLIMITCITY = "NOLIMITCITY",
  PENGUIN_KING = "PENGUIN KING",
}

export const SlotBlobUrl = "https://wrewards.s3.eu-north-1.amazonaws.com/slots_nw";
export const SlotProviders = [SlotProvider.NOLIMITCITY, SlotProvider.OCTOPLAY];
